<template>
  <InfoPage>
    <h1 class="display-2 mt-2 mt-md-6 mt-lg-12 mb-6">{{ $t("formulaireAdhesion.remerciementTitre") }}</h1>
    <div v-html="$t('formulaireAdhesion.remerciementParagraphe')"></div>
    <div v-if="avecDon" v-html="$t('formulaireDon.remerciementParagraphe')"></div>
    <div v-html="$t('transactionRealisee')"></div>
  </InfoPage>
</template>

<script>
import InfoPage from "@/layouts/InfoPage"

export default {
  components: {
    InfoPage
  },
  props: {
    avecDon: Boolean
  }
}
</script>

<style>
</style>